import React from 'react';
import { sum } from 'd3-array';
// import area from '@turf/area';
// import distance from '@turf/distance';
// import centroid from '@turf/centroid';
// import debounce from 'lodash/debounce';
// import { randomInt } from 'd3-random';
// import { format } from 'd3-format';
import MapBox from './MapBox';
import Bottombar from './Bottombar';
import Sidebar from './Sidebar';
// import Slider, { marks } from './Slider';
import Spline from './Spline';
// import AreaChart from './AreaChart';
import SaveMap from './SaveMap';

import './Keir.css'
import FutureBrisbane from './FutureBrisbane.svg'
import parkIcon from './parkIcon.png'

import { getTotals, geojsonLayers, getCurve, updateCalcHeight } from './Utils';



// function downloadURI(uri, name) {

  // var link = document.createElement("a");
  // link.download = name;
  // link.href = uri;
  // document.body.appendChild(link);
  // link.click();
  // // document.body.removeChild(link);
  // // delete link;
// }



const useData = () => {
  const [buildings, setBuildings] = React.useState();
  const [sa2s, setSa2s] = React.useState();

  React.useEffect(() => {
    fetch('https://storage.googleapis.com/city-app/brisbane/brisbane_population_sa2.json')
      .then(r => r.json())
      .then(r => {
        console.log(r)
        r.features.forEach(f => {
          f.id = f.properties.SA2_MAIN16
        })
        setSa2s(r)
      })

    fetch('https://storage.googleapis.com/city-app/brisbane/sites.json')
      .then(r => r.json())
      .then(r => {
        r.features.forEach((f, fi) => {
          f.properties.id = fi
        })
        setBuildings(r)
      })
  }, [])
  return {buildings, sa2s};
}


function App() {

  const mapRef = React.useRef();
  const [open, setOpen] = React.useState(false);

  // const [hoveredSA2, setHoveredSA2] = React.useState(null)
  const [splineData, setSplineData] = React.useState();
  const {buildings, sa2s} = useData()

  // console.log(filteredBuildings)
  // TODO cache

  // const [popDensity, setPopDensity] = React.useState(); // from spline, init to "2036 trend"
  // const [scenario, setScenario] = React.useState(marks[0]); // from year slider, init to 1 * "2036 trend"

  // React.useEffect(() => {
  //   if (!buildings) return
  //   if (!sa2s) return
  //   // setPopDensity(initPopDensity(buildings, sa2s))
  //   // setScenario(initScenario(buildings, sa2s))
  //   // setSplinePoints(initSplinePoints(buildings, sa2s))
  // }, [buildings, sa2s])

  React.useEffect(() => {
    if (!buildings) return
    updateCalcHeight(buildings, sa2s, splineData)
  }, [splineData])

  if (!buildings) return 'Loading...';
  if (!sa2s) return 'Loading...';

  // this should really only be done once
  const layers = geojsonLayers(buildings, sa2s)
  // const areaData = getTotals(sa2s);
  const curveData = getCurve(buildings, sa2s)

  // const currentPop = sum(sa2s.features.filter(f => !isNaN(f.properties['Pop in 2016'])), f => f.properties['Pop in 2016'])
  // const projectedPop = sum(sa2s.features.filter(f => !isNaN(f.properties['2036 Target Population'])), f => f.properties['2036 Target Population'])

  window.sa2s = sa2s
  window.sum = sum


  // {/*
  // <h3> Housing Brisbane's Population </h3>
  // <p>
  //   Inner Brisbane's Population is growing fast.
  // </p>
  // <AreaChart data={areaData}/>
  // <p>
  //   Scenario
  // </p>
  // <div className="sidebarSlider">
  //     <Slider onChange={setScenario}/>
  // </div>
  // */}
  // <h3> Brisbane's Population is {format(',d')(currentPop)} today. </h3>
  // <h3> It's set to grow to {format(',d')(projectedPop)} by 2036.</h3>
  // <h5> Current plans concentrate new residents in a few dense areas.</h5>
  // <h5 className="line-text"> The grey line shows the projected population density of each area, sorted sprawl to tall. </h5>
  // <h5 className="curve-text"> Drag the orange line to re-adjust density to how you'd like it. The orange buildings on the map now fit your chosen pattern of density.</h5>
  // <Spline curveData={curveData} setSplineData={setSplineData}/>
  // <h5 className="park-text">
  //   Need more open space? Click the polygon button on the top right to draw parks on the map.
  //   {/*
  //   <div className="mapboxgl-ctrl-group">
  //     <button className="mapbox-gl-draw_ctrl-draw-btn mapbox-gl-draw_polygon" />
  //   </div>
  //   */}
  // </h5>
  // <button onClick={saveMap}>Save map</button>
  // <img id="bigIMG"/>

  const clicker = I => {
    for (var i = 1; i < 4; i++) {
      const content = document.querySelector("#content" + i)
      if (I === i) {
        content.style.display = "block";
      } else {
        content.style.display = "none";
      }
    }
  }

  return (
    <React.Fragment>
      <Sidebar>
        <img src={FutureBrisbane} />
        <button onClick={() => clicker(1)} type="button" className="collapsible" id="collapsible1">Step 1: Navigate</button>
        <div className="content" id="content1">
            <p className="sml">Inner Brisbane's population will pass 380,000 in 2021. It will grow beyond 475,000 by 2036, based on my (and ABS's) modelling.</p>
            <p className="sml">Current city planning concentrate new residents in a few dense areas. As such, we've created a future map of Brisbane where new residential buildings are algorithmically placed based on historic and recent trends.</p>
            <p className="sml">Use your mouse or finger, scroll wheel and ctrl button to navigate the map.</p>
        </div>
        <button onClick={() => clicker(2)} type="button" className="collapsible" id="collapsible2">Step 2: Density</button>
        <div style={{"display": "none"}} className="content" id="content2">
            <p className="sml">Brisbane's surburbs have been arranged by projected population density, from sprawl to tall. <br/><br/>Drag the orange dot to adjust density. The orange buildings on the map will change to match your density distribution.</p>
            <Spline curveData={curveData} setSplineData={setSplineData}/>
        </div>
        <button onClick={() => clicker(3)} type="button" className="collapsible" id="collapsible3">Step 3: Greenspace</button>
        <div style={{"display": "none"}} className="content" id="content3">
            <img src={parkIcon} className="parkImg" />
            <p className="sml"> Need more open space? To add parks, click the polygon button on the top right of your browser window and then click on the map once for each corner of your park, click the first corner again to complete your new park. Not happy? Select your park and click the trash can to remove it. <br/><br/>If you place a park over the top of buildings, they will be removed.</p>
        </div>
        <button onClick={() => setOpen(true)} type="button" className="collapsible" id="collapsible4">Step 4: Save your map</button>
        {/* 
        <div style={{"display": "none"}} className="content" id="content4">
            <p className="sml">Record your vision for Brisbane in 2036.<br/><br/>If you choose, a copy will be sent to the State Library of Queensland, along with your name and a description, to be added to their digital catalogue.</p>
        </div>
        */}
        <SaveMap mapRef={mapRef} open={open} setOpen={setOpen} />

        <div className="nav-footer">
            <p className='xsml'><em>by</em>&nbsp;&nbsp;<a href="https://keir.winesmith.co">Dr. Keir Winesimth</a></p>
        </div>
      </Sidebar>
      <MapBox layers={layers} mapRef={mapRef} buildings={buildings}/>
      <Bottombar/>
    </React.Fragment>
  );
}

export default App;
